// AUTO-GENERATED CODE, DO NOT EDIT!
/* eslint-disable */

import * as Types from "../../../../types";

import gql from "graphql-tag";
import { GetStatusesEventFragmentDoc } from "../../../../Graphql-Utilities/getStatuses/getStatuses.generated-types";
import * as Urql from "urql";
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type WithdrawBriefEventFragment = {
  __typename?: "Event";
  UUID: string;
  proposalCount: number;
  status: Types.EventStatus;
};

export type WithdrawBriefMutationMutationVariables = Types.Exact<{
  UUID: Types.Scalars["ID"];
  releaseReason: Types.EventReleaseReason;
}>;

export type WithdrawBriefMutationMutation = {
  __typename?: "Mutation";
  cancelEvent: {
    __typename?: "Event";
    ID: number;
    UUID: string;
    status: Types.EventStatus;
  };
};

export const WithdrawBriefEventFragmentDoc = gql`
  fragment WithdrawBriefEvent on Event {
    UUID
    ...GetStatusesEvent
  }
  ${GetStatusesEventFragmentDoc}
`;
export const WithdrawBriefMutationDocument = gql`
  mutation WithdrawBriefMutation(
    $UUID: ID!
    $releaseReason: EventReleaseReason!
  ) {
    cancelEvent(UUID: $UUID, releaseReason: $releaseReason) {
      ID
      UUID
      status
    }
  }
`;

export function useWithdrawBriefMutationMutation() {
  return Urql.useMutation<
    WithdrawBriefMutationMutation,
    WithdrawBriefMutationMutationVariables
  >(WithdrawBriefMutationDocument);
}
